module.exports = __webpack_public_path__ + "static/986d84ee-7129-4adc-9c61-523393dad544-43564d0c766d48a4f87b11aae8661612.webp";